import { useEffect, useState } from "react";

import { db } from "../firebase/config";

export interface ScheduleProps {
  title: string;
  timeStart: Date;
  timeEnd: Date;
  description: string;
  private?: boolean;
}

const useSchedule = () => {
  const [schedule, setSchedule] = useState<ScheduleProps[]>([]);
  const sortedSchedule = schedule.sort((a, b) => {
    if (a.timeStart > b.timeStart) {
      return 1;
    } else if (a.timeStart < b.timeStart) {
      return -1;
    }

    return 0;
  });

  useEffect(() => {
    const fetch = async () => {
      try {
        const docs = await db.collection("schedule").get();
        docs.forEach((doc) => {
          const data = doc.data();
          const { timeStart, timeEnd } = data;

          setSchedule((prev: any) => {
            return [
              ...prev,
              {
                ...data,
                timeStart: timeStart.toDate(),
                timeEnd: timeEnd.toDate(),
              },
            ];
          });
        });
      } catch (error) {
        console.error(error);
      }
    };

    fetch();
  }, []);

  return sortedSchedule;
};

export default useSchedule;
